import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {t} from '../../Translations'
import Label from './Label';
import Carousel from 'nuka-carousel';
import Peugeot from './Peugeot.png';
import Citroen from './Citroen.png';
import DS from './DS.png';
import Button from "../widgets/Button";
import {getCode} from "../../App";
import Configuration from '../../Configuration';


class Carrousel extends Component {

    render() {
        const {index,classLabel, classes, onClick, disabled, data, value} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        const sliderArrowAp = (client.trim() === "ap" ? " slider-arrow-ap":"");
        let LCDV4 = getCode.substr(0, 4);
        let TrimLevel = getCode.substr(4, 2);
        let codeJante = [];
        let jante = [];
        let imgUrls = [];
        var def_image = "";
        var one_rim = (data.rims.length === 1) ? true : false;
        data.rims.map(item => codeJante[item.value] = item.label);
        data.rims.map(item => codeJante[item.value]);


        if (Configuration.brand === 'P') {
            Object.keys(codeJante, jante).forEach(function (item) {
                imgUrls[item] = [];
                (item === 'XXXXX' ?
                    imgUrls[item]["url"] = Peugeot :
                    imgUrls[item]["url"] = "https://visuel3d-secure.peugeot.com/v3dcentral/" + LCDV4 + "/" + TrimLevel + "/RolloversNDP/Features/" + item.substr(1, 4) + "/" + item.substr(1, 4) + "_conso.png");
                imgUrls[item]["label"] = codeJante[item];
                imgUrls[item]["code"] = item;

            });
        }
        else if (Configuration.brand === 'DS') {
            Object.keys(codeJante).forEach(function (item) {
                imgUrls[item] = [];
                (item === 'XXXXX' ?
                    imgUrls[item]['url'] = DS :
                    imgUrls[item]['url'] ="https://visuel3d-secure.citroen.com/V3DCentral/"+LCDV4+"/SY/ThumbnailsV2/Features/"+item.substr(1,4)+".png");
                imgUrls[item]['label'] = codeJante[item];
                imgUrls[item]["code"] = item;
            });
        }
        else if (Configuration.brand === 'C') {
            Object.keys(codeJante).forEach(function (item) {
                imgUrls[item] = [];
                (item === 'XXXXX' ?
                    imgUrls[item]['url'] = Citroen :
                    imgUrls[item]['url']="https://visuel3d-secure.citroen.com/V3DCentral/"+LCDV4+"/"+TrimLevel+"/ThumbnailsV2/Features/"+item.substr(1,4)+".png");
                imgUrls[item]['label'] = codeJante[item];
                imgUrls[item]["code"] = item;

            });
        }

        if (Configuration.brand === 'C'){
            def_image = ""+Citroen+"";
        }else if(Configuration.brand === 'DS'){
            def_image = ""+DS+"";
        }else {
            def_image = ""+Peugeot+"";
        }

        return (
            <div key={index} className="row my-4 my-md-2">
                <div className="col-12 col-md-6 info-bulle">
                    <Label>{`${t('Step1_form_rims')}*`}</Label>
                </div>
                <div className="col-12 col-md-6">
                    <label className={classLabel} style={{color: "grey"}}>{t('Step1_form_info_selectionnez')}</label>
                    <Carousel
                        className={client.trim()}
                        withoutControls={one_rim}
                        renderCenterLeftControls={({previousSlide}) => (
                            <button className={"cccu-button"+sliderArrowAp} onClick={previousSlide}><i className={"fa fa-2x fa-angle-left fa-arrow-cccu"+client} aria-hidden="true"></i></button>
                        )}
                        renderCenterRightControls={({nextSlide}) => (
                            <button className={"cccu-button"+sliderArrowAp} onClick={nextSlide}><i className={"fa fa-2x fa-angle-right fa-arrow-cccu"+client} aria-hidden="true"></i></button>
                        )}
                    >
                        {(Object.keys(imgUrls).map(function(e) {
                            return imgUrls[e]
                        })).map(function (item, key) {
                            return (
                                <div className={classes} key={key} >
                                    <div className="row" id={key}>
                                        <img src={item.url} key={key} data-label={item.label} code-jante={item.code}
                                             className={"slider-image h-100 w-100 px-5"+client} alt="" onError={(event)=>{ event.target.src = def_image; }}/>
                                    </div>
                                    <div className="row h-100 m-0 px-3">
                                        <label className={"cccu-label caroussel-digital-one-label digital-one text-center "+classLabel+" mx-1 pb-0 mb-0"}>{item.label}</label>
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>

                    <Button
                        className={"btn-cccu-step1 "+classes} onClick={onClick} disabled={disabled} value={value}>
                        {t('Step1_form_info_valider')}
                    </Button>

                </div>
            </div>
        );
    }
}

Carrousel.propTypes = {
    index: PropTypes.number,
    classes: PropTypes.string,
    classLabel: PropTypes.string,
    onChange: PropTypes.func
};
Carrousel.defaultProps = {
    index: 0,
    loading: false,
    classLabel:""
};

export default Carrousel;


// WEBPACK FOOTER //
// ./src/components/widgets/Carrousel.js